module.exports = __webpack_public_path__ + "images/bote8357452441eca9afbc39be074b8b650.svg";